export default "__VITE_ASSET__CNwdhl2O__"